export const enum CompileStatus {
    Copied,
    Compiled,
    Omitted,
    Failed,
}
